import * as React from 'react';
import { History } from 'history';
import Model from './quizresult-model';
import BaseList from '../base/base-list.component';

interface IProps {  
  history: History;
  root?: string;
  caption?: string;
  parentId?: number;
  eventName?: string;
  actions?: any;
  readOnly?: boolean;
  disableBackButton?: boolean;
  disableCard?: boolean;
}

interface IState {
}

export default class QuizresultList extends React.Component<IProps, IState> {
  
  constructor(props: IProps) {
    super(props);
  }
  
  private onLoadAll = (data: any) => {
  }

  public render(): React.ReactNode {    
    return (
      <BaseList history={this.props.history} parentId={this.props.parentId} id={this.props.parentId} caption={this.props.caption} endPointFilter={Model.endPointFilterList(this.props.eventName, this.props.parentId)} url={(this.props.root || '') + Model.url} model={Model} header={this.props.eventName && Model.columnResult} actions={this.props.actions} onLoadAll={this.onLoadAll} readOnly={this.props.readOnly}  disableBackButton={this.props.disableBackButton} disableCard={this.props.disableCard}/>
    );
  }
}
